import a, { useState as n, useRef as E, useEffect as m } from "react";
import { calculateInnerElements as x } from "../../utils/calculateInnerElements.js";
import { getInnerElementsSizes as g } from "../../utils/getInnerElementsSizes.js";
const h = _ref => {
  let {
    children: l,
    width: s,
    fixedHeightElements: u
  } = _ref;
  var r;
  const [c, f] = n(!0),
    t = E(null),
    [p, _] = n((r = l == null ? void 0 : l.length) != null ? r : 0),
    [d, b] = n([]),
    v = p - 1;
  return m(() => {
    _(x(d, t));
  }, [d, s]), m(() => {
    var e;
    (e = document == null ? void 0 : document.fonts) == null || e.ready.then(() => {
      f(!1), b(g(t));
    });
  }, []), !l && u ? a.createElement("span", {
    className: "olx-ad-card__labels-items--fixed"
  }) : l ? a.createElement("ul", {
    className: "olx-ad-card__labels-items",
    "data-loading": c,
    ref: t,
    "data-testid": "labelGroup"
  }, l.map((e, o) => {
    var i;
    return a.createElement("li", {
      className: "olx-ad-card__labels-item",
      key: (i = e == null ? void 0 : e.key) != null ? i : o,
      "data-visible": o <= v
    }, e);
  })) : null;
};
export { h as Labels };